import registerComponent from './register/index.vue';
import OrgListComponent from './partner-list/index.vue';
import OrgListComponent1 from './partner-list1/index.vue';
import OrgDetailComponent from './partner-detail/index.vue';

export default [
  {
    path: 'fileprepare',
    component: registerComponent,
    meta: {
      title: '报备',
      breadCrumbShowIndexArr: [1, 2]
    }
  },
  {
    path: 'partner-list',
    component: OrgListComponent,
    meta: {
      title: ''
    },
    breadCrumbShowIndexArr: [0, 1, 2]
  },
  {
    path: 'partner-list1',
    component: OrgListComponent1,
    meta: {
      title: ''
    },
    breadCrumbShowIndexArr: [0, 1, 2]
  },
  {
    path: 'partner-detail1',
    component: OrgDetailComponent,
    meta: {
      title: '农机服务详情',
      breadCrumbShowIndexArr: [1, 2]
    }
  },
  {
    path: 'partner-detail2',
    component: OrgDetailComponent,
    meta: {
      title: '飞防服务详情',
      breadCrumbShowIndexArr: [1, 2]
    }
  }
];

